import { BookIcon } from 'Book/shared';
import React from 'react';
import { useTheme } from 'styled-components';

import { IconWrapper } from './styles';

export default ({ service }: { service: string }) => {
  const theme = useTheme();

  return (
    <IconWrapper className="icon-wrapper">
      <span className="icon">
        <BookIcon
          icon={service}
          width={32}
          height={32}
          primaryColor={theme.colors.text.default}
        />
      </span>
    </IconWrapper>
  );
};
